import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';

export default function TicketDetailSkeleton() {
  return (
    <div>
      <div className="placeholder-glow mb-3">
        <span className="placeholder col-5" style={{ height: 32 }} />
      </div>
      <div className="d-flex gap-2 mb-3">
        <span className="placeholder rounded col-2" style={{ height: 24 }} />
        <span className="placeholder rounded col-2" style={{ height: 24 }} />
      </div>
      <Card className="mt-2">
        <CardBody>
          <div className="placeholder-glow">
            <span className="placeholder col-12 mb-2" />
            <span className="placeholder col-12 mb-2" />
            <span className="placeholder col-7" />
          </div>
        </CardBody>
      </Card>
      <Card className="mt-2">
        <CardBody>
          <span className="placeholder col-3 mb-3 d-block" style={{ height: 24 }} />
          <div className="d-flex justify-content-center py-3">
            <Spinner color="primary" />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
